export const REMARKS_PLACEHOLDER = 'All remarks goes here';
export const DATE_FORMAT = 'DD/MM/YYYY [-] hh:mm A';
